import type { IconSvgObject } from './types';

const CircleLockMinus01Icon: IconSvgObject = [
  ["path", { d: "M11.25 21.9989C7.31358 22.0964 4.25 18.8064 4.25 14.999C4.25 11.133 7.36877 7.99894 11.216 7.99894C13.7944 7.99894 16.0456 9.40664 17.25 11.499", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15.75 9.49894V6.49894C15.75 4.01366 13.7353 1.99894 11.25 1.99894C8.76472 1.99894 6.75 4.01366 6.75 6.49894V9.49894", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.75 16.9989H19.75", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CircleLockMinus01Icon;
